export enum OperationStatus {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    ABORTED = 'ABORTED',
}